import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  min-width: 22px;
  min-height: 22px;
  display: flex;
  align-items: center;
`;
